import * as React from 'react';
import { Link } from 'react-router-dom';

interface IProps {
    parentProps: any
}


class HeaderComp extends React.Component<IProps, any> {
    public state = {
        isOpen: false,
        navList: [
            {name: '首页', num: '0', url: '/'},
            {name: '快讯', num: '1370', url: '/listPage/1370?name='+encodeURIComponent('快讯')},
            {name: '人物', num: '1369', url: '/listPage/1369?name='+encodeURIComponent('人物')},
            {name: '企业', num: '1368', url: '/listPage/1368?name='+encodeURIComponent('企业')},
            {name: '观察', num: '1371', url: '/listPage/1371?name='+encodeURIComponent('观察')},
            {name: '直播', num: '-1', url: '//zhibo.ibuychem.com/frontend/web/index.php'},
            {name: '设计', num: '1404', url: '/listPage/1404?name='+encodeURIComponent('设计')},
            {name: '百科', num: '1401', url: '/listPage/1401?name='+encodeURIComponent('百科')},
            {name: '数据', num: '1374', url: '/listPage/1374?name='+encodeURIComponent('数据')},
            {name: '政策', num: '1375', url: '/listPage/1375?name='+encodeURIComponent('政策')},
            {name: '软装', num: '1379', url: '/listPage/1379?name='+encodeURIComponent('软装')},
            {name: '卫浴', num: '1376', url: '/listPage/1376?name='+encodeURIComponent('卫浴')},
            {name: '橱柜门窗', num: '1377', url: '/listPage/1377?name='+encodeURIComponent('橱柜门窗')},
            {name: '家具', num: '1380', url: '/listPage/1380?name='+encodeURIComponent('家具')},
        ],
        navId: this.props.parentProps.match.params.id || '0'
    }
    public componentWillReceiveProps(props: IProps) {
        if(props.parentProps.match.params.id === this.state.navId) {
            return;
        }
        this.setState({
            navId: props.parentProps.match.params.id || '0'
        });
    }
    public render() {
        const state = this.state;
        return (
            <div className="head">
                <div className="header">
                    <Link to="/" className="logo">
                        <img src={require('../../assets/images/logo.png')} />
                    </Link>
                </div>
                <div className={`nav-menu ${state.isOpen ? 'active' : ''}`}>
                    <ul>
                        {
                            state.navList.map((v: any, k: number) => {
                                return (
                                    <li key={`head-nav-item${k}`} className={state.navId === v.num ? 'active' : ''}>{v.name === '直播' ? <a href={v.url}>{v.name}</a> : <Link to={v.url}>{v.name}</Link>}</li>
                                );
                            })
                        }
                    </ul>
                    <span className={`nav-menu-switch ${state.isOpen ? 'active' : ''}`} onClick={() => this._switchNavAction()}>+</span>
                </div>
            </div>
        )
    }
    // 切换导航显示隐藏
    private _switchNavAction() {
        this.setState({ isOpen: !this.state.isOpen});
    }
}

export default HeaderComp;


// WEBPACK FOOTER //
// ./src/components/common/header.tsx